import { create, w, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { createNlsMiddleware, registry } from '@holmescorp/lcc-state';
import { TopicsetViz } from '@holmescorp/prepost-viz';

import css from '../css/topic-progress.m.css';

const nls = createNlsMiddleware('ditabook');
const factory = create({
	theme,
	nls
});

export const TopicProgress = factory(({ middleware: { theme, nls } }) => {
	const {
		messages: {
			topic_progress_title = '[ditabook] topic_progress_title',
			topic_progress_about = '[ditabook] topic_progress_about',
			topic_progress_score = '[ditabook] topic_progress_score',
			topic_progress_target = '[ditabook] topic_progress_target'
		}
	} = nls();
	const themeCss = theme.classes(css);

	return v('div', { xqa: 'report topic-progress', tabIndex: 0, classes: [themeCss.root] }, [
		v('h2', { classes: [themeCss.title] }, [topic_progress_title]),
		v('p', { classes: [themeCss.about] }, [topic_progress_about]),
		v('div', { classes: [themeCss.vizblock] }, [w(TopicsetViz, {})]),
		v('div', { classes: [themeCss.legend] }, [
			v('div', {}, [
				v('span', { classes: [themeCss.scoreIcon] }, [`\u25a0 `]),
				v('span', {}, [topic_progress_score])
			]),
			v('div', {}, [
				v('span', { classes: [themeCss.targetIcon] }, [`\u23ae `]),
				v('span', {}, [topic_progress_target])
			])
		])
	]);
});

registry.define('TopicProgress', TopicProgress);
